import React from 'react';
import { IoClose } from "react-icons/io5";
import { FaCheck } from "react-icons/fa6";

interface ImageBoxProps {
  key: string;
  label: string;
  value: boolean;
  onClick: () => void;
  img: React.ReactNode;
}

const ImageBox: React.FC<ImageBoxProps> = ({ label, value, onClick, img }) => {
  return (
    <div
      className={`relative flex flex-col items-center justify-center w-[100px] h-[80px] rounded-lg cursor-pointer border-2 transition-all duration-200 select-none
        ${value
          ? "bg-white shadow-md"
          : "bg-gray-100 border-gray-300 opacity-60"
        }`}
      onClick={onClick}
    >
      {!value ? (
        <div className="absolute -top-[1px] -right-[1px]">
          {!value ? <IoClose size={24} className="text-red-500" /> : <FaCheck size={24} className="text-green-500" />}
        </div>
      ) : (
        <div className="absolute top-[1px] right-[3px]">
          <FaCheck size={20} className="text-green-500" />
        </div>
      )}
      {img}
      <div className={`text-xs text-center font-semibold ${value ? "text-gray-800" : "text-gray-400"}`}>
        {label}
      </div>
    </div>
  );
};

export default ImageBox; 